import { Eye, Compass, MoveDiagonal, Sprout } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const benefits = [
  { icon: Eye, title: "Voir autrement une situation", desc: "Sortir d'une lecture figée." },
  { icon: Compass, title: "Comprendre les mécanismes", desc: "Identifier ce qui se rejoue." },
  { icon: MoveDiagonal, title: "Prendre du recul", desc: "Retrouver une juste distance." },
  { icon: Sprout, title: "Engager un changement", desc: "Mettre un premier mouvement." },
];

export default function Benefits() {
  return (
    <section
      data-testid="ateliers-benefits"
      className="py-24 md:py-32 bg-[#F3EEF4]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Bénéfices
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Ce que cela permet
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map(({ icon: Icon, title, desc }, i) => (
            <Reveal key={title} delay={i * 0.06}>
              <div
                data-testid={`ateliers-benefit-${i}`}
                className="h-full p-7 bg-white rounded-3xl border border-[#DDD7E2] hover:border-[#C98FA3] transition-colors"
              >
                <div className="w-11 h-11 rounded-full bg-[#F3EEF4] flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#3A2E6E]" />
                </div>
                <h3 className="font-medium text-base mt-5 text-[#1E1E2A]">{title}</h3>
                <p className="mt-2 text-sm text-[#5F6170] leading-relaxed">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
